<span class="spinner spinner-white">
    <div>
      <div class="spinner-div">
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
        <div class="spinner_bar__Bh"></div>
      </div>
    </div>
</span>